import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Branch } from 'src/app/services/branch/branch.model';
import { setAddressForGoogleMaps as setAddress } from 'src/app/helpers/google-maps-search.helper';

/**
 * Use this component as a list item template for branch results from a zip code search.
 * This component will also display the branch image at the header of the card.
 *
 * @prop branch: object of type {Branch}.
 * @prop showSelectionButton: This will show a {Select Branch} button that will emit a {clickEvent}.
 * @emits clickEvent: Emits the selected branch DomainID of type number.
 */
@Component({
  selector: 'app-branch-selection',
  templateUrl: './branch-selection.component.html',
  styleUrls: ['./branch-selection.component.scss'],
})
export class BranchSelectionComponent implements OnInit {
  @Output() clickEvent = new EventEmitter<number>();
  @Input() branch: Branch | null = null;
  @Input() showSelectionButton = false;

  setGoogleMapsSearch = setAddress;

  constructor() {}

  ngOnInit(): void {}

  onClick(domainId: number) {
    this.clickEvent.emit(domainId);
  }
}
